export const comments_3464722 = {"data":{"data":[],"links":{}}}